import { Injectable } from '@angular/core';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import firebase from 'firebase/app';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, combineLatest } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { resolveDefinition } from '@angular/core/src/view/util';
import { Http, Headers, RequestOptions } from '@angular/http';
//import { FireSQL } from 'firesql';
import 'firebase/firestore';
import { EnvDataService } from '../../../app/services/env-data-service';
// import {User} from '../models/user.model';
// import {Contact} from '../models/contact.model';
@Injectable()
export class ContactFormService {

  public userRole: any;
  public deleted_access: any;
  // userCollection: AngularFirestoreCollection<User>;
  // contactCollection: AngularFirestoreCollection<Contact>;
  // contactItem: Observable<Contact[]>;
  constructor(
    public db: AngularFirestore,
    private EnvDataService:EnvDataService,
    private _http:Http
  ) {
  }

  // // get user details by sending form document id

  //   userdetailsbyadfid(SDF_form_document_id)
  //   {
  //       console.log(SDF_form_document_id);
  //       let thiss = this;
  //       return new Promise((resolve, reject) => {
  //         let SDF_form = firebase.firestore().collection("SDF_form").doc(SDF_form_document_id);

  //         let user_collections : any;
  //         let primary_applicant: any;
  //         let secondary_applicant:any;

  //         SDF_form.get().then(function(SDF_form_doc) {
  //             if (SDF_form_doc.exists) {
  //                 let sdf_data = SDF_form_doc.data();
  //                 let main_uid = sdf_data.uid;
  //                 main_uid ='rr8EbQQs2nR22RkN93zeMEefusR2';
  //                 SDF_form_document_id = 'rr8EbQQs2nR22RkN93zeMEefusR2_1596114405140';
  //                 let docRef1 = firebase.firestore().collection("users").doc(main_uid);
  //                 docRef1.get().then(function(doc) {
  //                     thiss.get_first_user_data(SDF_form_document_id, main_uid).subscribe((data)=>{
  //                         //console.log(data);
  //                         primary_applicant = data
  //                         let primary_data = doc.data();
  //                         user_collections = {
  //                           primary_data:primary_data,
  //                           primary_details:primary_applicant[0]

  //                       }
  //                       //return user_collections;
  //                       resolve(user_collections);
  //                     });


  //                 },(err) => {
  //                     reject(err);
  //                 })
  //             }
  //         })
  //       }).then((user_collections) => {

  //         return new Promise((resolve, reject) => {

  //           thiss.get_second_user_data(SDF_form_document_id).subscribe((result)=>{

  //             let array_result =[];
  //             const requests = result.map(function (data) {

  //               const promise = new Promise(function (resolve, reject) {

  //                 firebase.firestore().collection("users").doc(data.uid).get().then((userresult) =>{
  //                    let users = userresult.data();
  //                     let user_object = {
  //                        secondary_data : users,
  //                        secondary_details:data
  //                     }
  //                     array_result.push(user_object);
  //                     resolve(true);
  //                 });



  //               })
  //               return promise;



  //           });
  //             Promise.all(requests).then(function (result) {
  //                 //console.log(finalexams);
  //                 console.log(array_result);
  //                 console.log(user_collections);

  //                 let final_result = {
  //                   primary_applicant:user_collections,
  //                   secondary_applicant:array_result
  //                 }

  //                 resolve (final_result);

  //             })

  //           });

  //         })

  //       })

  //   }


  //   // get users table data by sending email id

  //   getUsersDataByEmail(email_id) {

  //     let thiss = this;
  //     email_id = 'kmFMykdLSmpjdOy10TnP'
  //     return new Promise((resolve, reject) => {

  //       thiss.get_users_table_data(email_id).subscribe((data)=>{
  //          // console.log(data);
  //           resolve(data[0]);
  //       })

  //     })

  //   }

  // save applicant contact list data

  saveApplicantDetails(applicant_object) {
    debugger;
    //saving primary applicant data

//  applicant_object = {
//        user_data:{


//          firstname:'first 1',
//          lastname:'testing 1',
//          email: 'sultantest11@gmail.com',
//          mobile_phone: '126543',
//          password:  '1236547885',
//          deleted:0,
//          created_date: new Date().getTime(),
//          roles:{


//            contact:true
//          }

//        },
//    }

let thiss = this;
 return new Promise((resolve,reject) => {

   this.checkuserexist(applicant_object.user_data).then((data:any)=> {

     if(!data.status) {

            debugger;
            // console.log(docRef)
            // console.log(docRef.id);
            let user_id = data.uid;
            let newuser = applicant_object.user_data;
            newuser.uid = user_id;


            let keywordNameWithUser = thiss.createKeywords(`${newuser.firstname.toLowerCase()} ${newuser.lastname.toLowerCase()}`);
            let keywordLastNameWithUser = thiss.createKeywords(`${newuser.lastname.toLowerCase()}`);



            const keywordNameWithEmail = thiss.createKeywords(`${newuser.email.toLowerCase()}`);
            //var c = keywordNameWithUser.concat(keywordNameWithEmail);

            const keywordNameWithPhone = thiss.createKeywords(`${newuser.mobile_phone}`);
            let keywordNameWithBroker;
            let keywordLastNameWithBroker;
            if(data.broker_data) {
               keywordNameWithBroker = thiss.createKeywords(`${data.broker_data.firstname.toLowerCase()} ${data.broker_data.lastname.toLowerCase()}`);
               keywordLastNameWithBroker = thiss.createKeywords(`${data.broker_data.lastname.toLowerCase()}`);
            }
            else {
              keywordNameWithBroker = []
              keywordLastNameWithBroker = []
            }


            let final_keyword_list = [...keywordNameWithUser,...keywordNameWithEmail,...keywordNameWithPhone,...keywordNameWithBroker,...keywordLastNameWithUser,...keywordLastNameWithBroker];

            var d = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)

            newuser.keywords = d;
            firebase.firestore().collection("users").doc(user_id).set(newuser).then(function (querySnapshot2) {

              if(applicant_object.contact_details) {
                applicant_object.contact_details.uid = user_id;
                console.log('its is okay');
                firebase.firestore().collection("contact_details").add(applicant_object.contact_details).then(function(details) {
                  console.log(details);
                  console.log(applicant_object);
                   let adf_objects = {
                    adf_form_id:'',
                    application_status:'open',
                    contacts:[
                      {
                        contact_details:applicant_object.contact_details,
                        type:'primary',
                        user_data:newuser
                      }
                    ],
                    created_date:newuser.created_date,
                    deleted:0,
                    liabilities:[],
                    primary_contact_id:newuser.uid,
                    primayr_goal_intention:'',
                    realestate:[],
                    reference_broker:newuser.reference_broker,
                    title:newuser.newuser.firstname+' '+newuser.lastname,
                    draft:1,
                    user_ids:[
                      newuser.uid
                    ],
                    keywords:[]

                   }
                   let keywordNameWithStatus;
                   if(adf_objects.application_status) {
                      keywordNameWithStatus = thiss.createKeywords(`${adf_objects.application_status.toLowerCase()}`);
                   }
                   else {
                      keywordNameWithStatus = [];
                   }

                   let keywordNameWithTitle = thiss.createKeywords(`${adf_objects.title.toLowerCase()}`);
                   let keywordNameWithDate;
                   if(adf_objects.created_date) {
                     let d = new Date(adf_objects.created_date);
                     let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();

                      keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                   }
                   else {
                     keywordNameWithDate = [];
                   }


                   let final_keyword_adflist = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate,...keywordLastNameWithUser,...keywordLastNameWithBroker];

                     var filtersdfdata = final_keyword_adflist.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
                     adf_objects.keywords = filtersdfdata;

                  firebase.firestore().collection("adf_forms").add(adf_objects).then(function(adfdetails) {

                    let adf_id = adfdetails.id;
                    adf_objects.adf_form_id = adf_id;

                    let new_adf = adf_objects;
                    firebase.firestore().collection("adf_forms").doc(adf_id).set(new_adf).then(function (querySnapshot2) {


                      firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {

                        querySnapshot3.forEach(function (anaDoc) {

                          anaDoc.ref.update({
                            total_adf:firebase.firestore.FieldValue.increment(1),
                            total_users:firebase.firestore.FieldValue.increment(1),
                          });
                        })

                        let message = "applicant added successfully";

                            let result = {
                              message:message,
                              uid:user_id,
                              adf_form_id:adf_id,
                              status:true
                            }
                          resolve(result);

                      })



                    })

                    })
                      //   let message = "applicant added successfully";

                      //   let result = {
                      //     message:message,
                      //     uid:user_id,
                      //     status:true
                      //   }
                      // resolve(result);
                  })
               }
               else {
                console.log('its is not okay');

                let adf_objects = {
                  adf_form_id:'',
                  application_status:'open',
                  contacts:[
                    {
                      contact_details:{},
                      type:'primary',
                      user_data:newuser
                    }
                  ],
                  created_date:newuser.created_date,
                  deleted:0,
                  liabilities:[],
                  primary_contact_id:newuser.uid,
                  primayr_goal_intention:'',
                  realestate:[],
                  reference_broker:newuser.reference_broker,
                  title:newuser.firstname+' '+newuser.lastname,
                  draft:1,
                  user_ids:[
                    newuser.uid
                  ],
                  keywords:[]

                 }

                 let keywordNameWithStatus;
                 if(adf_objects.application_status) {
                    keywordNameWithStatus = thiss.createKeywords(`${adf_objects.application_status.toLowerCase()}`);
                 }
                 else {
                    keywordNameWithStatus = [];
                 }

                 let keywordNameWithTitle = thiss.createKeywords(`${adf_objects.title.toLowerCase()}`);
                 let keywordNameWithDate;
                 if(adf_objects.created_date) {
                   let d = new Date(adf_objects.created_date);
                   let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();

                    keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                 }
                 else {
                   keywordNameWithDate = [];
                 }


                 let final_keyword_adflist = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate];

                   var filtersdfdata = final_keyword_adflist.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
                   adf_objects.keywords = filtersdfdata;

                firebase.firestore().collection("adf_forms").add(adf_objects).then(function(adfdetails) {

                  let adf_id = adfdetails.id;
                  adf_objects.adf_form_id = adf_id;

                  let new_adf = adf_objects;
                  firebase.firestore().collection("adf_forms").doc(adf_id).set(new_adf).then(function (querySnapshot2) {


                    firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {

                      querySnapshot3.forEach(function (anaDoc) {
                        let old_adf = anaDoc.data().total_adf;
                        let total_adf = parseInt(old_adf) + 1;
                        let old_user = anaDoc.data().total_users;
                        let total_users = parseInt(old_user) + 1;

                        anaDoc.ref.update({
                          total_adf:firebase.firestore.FieldValue.increment(1),
                          total_users:firebase.firestore.FieldValue.increment(1),
                        });

                        let message = "applicant added successfully";

                        let result = {
                          message:message,
                          uid:user_id,
                          adf_form_id:adf_id,
                          status:true
                        }
                        resolve(result);

                      })
                    })


                  })

                  })

                      //   let message = "applicant added successfully";

                      //   let result = {
                      //     message:message,
                      //     uid:user_id,
                      //     status:true
                      //   }
                      // resolve(result);
                  }
            })



     }
     else {
       resolve(data)
     }

});

 })

}


  // save new adf form

  saveNewApplication(applicant_object) {
    debugger;


let thiss = this;
 return new Promise((resolve,reject) => {

   this.checknewuserexist(applicant_object.user_data).then((data:any)=> {

            console.log(data);

            let user_id = data.uid;
            let newuser = applicant_object.user_data;
            newuser.uid = user_id;

            let keywordNameWithUser = thiss.createKeywords(`${newuser.firstname.toLowerCase()} ${newuser.lastname.toLowerCase()}`);
            let keywordLastNameWithUser = thiss.createKeywords(`${newuser.lastname.toLowerCase()}`);



            const keywordNameWithEmail = thiss.createKeywords(`${newuser.email.toLowerCase()}`);
            //var c = keywordNameWithUser.concat(keywordNameWithEmail);

            const keywordNameWithPhone = thiss.createKeywords(`${newuser.mobile_phone}`);
            let keywordNameWithBroker;
            let keywordLastNameWithBroker;
            if(data.broker_data) {
               keywordNameWithBroker = thiss.createKeywords(`${data.broker_data.firstname.toLowerCase()} ${data.broker_data.lastname.toLowerCase()}`);
               keywordLastNameWithBroker = thiss.createKeywords(`${data.broker_data.lastname.toLowerCase()}`);
            }
            else {
              keywordNameWithBroker = []
              keywordLastNameWithBroker = []
            }


            let final_keyword_list = [...keywordNameWithUser,...keywordNameWithEmail,...keywordNameWithPhone,...keywordNameWithBroker,...keywordLastNameWithUser,...keywordLastNameWithBroker];

            var d = final_keyword_list.filter((item, pos) => final_keyword_list.indexOf(item) === pos)

            newuser.keywords = d;
            firebase.firestore().collection("users").doc(user_id).set(newuser).then(function (querySnapshot2) {

              if(applicant_object.contact_details) {
                applicant_object.contact_details.uid = user_id;
                console.log('its is okay');
                firebase.firestore().collection("contact_details").add(applicant_object.contact_details).then(function(details) {
                  console.log(details);
                  console.log(applicant_object);
                   let adf_objects = {
                    adf_form_id:'',
                    application_status:'open',
                    contacts:[
                      {
                        contact_details:applicant_object.contact_details,
                        type:'primary',
                        user_data:newuser
                      }
                    ],
                    created_date:new Date().getTime(),
                    deleted:0,
                    liabilities:[],
                    primary_contact_id:newuser.uid,
                    primayr_goal_intention:'',
                    realestate:[],
                    reference_broker:newuser.reference_broker,
                    title:newuser.firstname+' '+newuser.lastname,
                    draft:1,
                    user_ids:[
                      newuser.uid
                    ],
                    keywords:[]

                   }
                   let keywordNameWithStatus;
                   if(adf_objects.application_status) {
                      keywordNameWithStatus = thiss.createKeywords(`${adf_objects.application_status.toLowerCase()}`);
                   }
                   else {
                      keywordNameWithStatus = [];
                   }

                   let keywordNameWithTitle = thiss.createKeywords(`${adf_objects.title.toLowerCase()}`);
                   let keywordNameWithDate;
                   if(adf_objects.created_date) {
                     let d = new Date(adf_objects.created_date);
                     let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();

                      keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                   }
                   else {
                     keywordNameWithDate = [];
                   }


                   let final_keyword_adflist = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate,...keywordLastNameWithUser,...keywordLastNameWithBroker];

                     var filtersdfdata = final_keyword_adflist.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
                     adf_objects.keywords = filtersdfdata;

                  firebase.firestore().collection("adf_forms").add(adf_objects).then(function(adfdetails) {

                    let adf_id = adfdetails.id;
                    adf_objects.adf_form_id = adf_id;

                    let new_adf = adf_objects;
                    firebase.firestore().collection("adf_forms").doc(adf_id).set(new_adf).then(function (querySnapshot2) {


                      firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {

                        querySnapshot3.forEach(function (anaDoc) {

                          anaDoc.ref.update({
                            total_adf:firebase.firestore.FieldValue.increment(1),
                            total_users:firebase.firestore.FieldValue.increment(1),
                          });
                        })

                        let message = "applicant added successfully";

                            let result = {
                              message:message,
                              uid:user_id,
                              adf_form_id:adf_id,
                              status:true
                            }
                          resolve(result);

                      })



                    })

                    })
                      //   let message = "applicant added successfully";

                      //   let result = {
                      //     message:message,
                      //     uid:user_id,
                      //     status:true
                      //   }
                      // resolve(result);
                  })
               }
               else {
                    console.log('its is not okay');
                    newuser.created_date = new Date().getTime();

                    let adf_objects = {
                      adf_form_id:'',
                      application_status:'open',
                      contacts:[
                        {
                          contact_details:{},
                          type:'primary',
                          user_data:newuser
                        }
                      ],
                      created_date:new Date().getTime(),
                      deleted:0,
                      liabilities:[],
                      primary_contact_id:newuser.uid,
                      primayr_goal_intention:'',
                      realestate:[],
                      reference_broker:newuser.reference_broker,
                      title:newuser.firstname+' '+newuser.lastname,
                      draft:1,
                      user_ids:[
                        newuser.uid
                      ],
                      keywords:[]

                    }

                    let keywordNameWithStatus;
                    if(adf_objects.application_status) {
                        keywordNameWithStatus = thiss.createKeywords(`${adf_objects.application_status.toLowerCase()}`);
                    }
                    else {
                        keywordNameWithStatus = [];
                    }

                    let keywordNameWithTitle = thiss.createKeywords(`${adf_objects.title.toLowerCase()}`);
                    let keywordNameWithDate;
                    if(adf_objects.created_date) {
                      let d = new Date(adf_objects.created_date);
                      let dateobj = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();

                        keywordNameWithDate = thiss.createKeywords(`${dateobj}`);
                    }
                    else {
                      keywordNameWithDate = [];
                    }


                    let final_keyword_adflist = [...keywordNameWithUser,...keywordNameWithBroker,...keywordNameWithStatus,...keywordNameWithTitle,...keywordNameWithDate];

                      var filtersdfdata = final_keyword_adflist.filter((item, pos) => final_keyword_list.indexOf(item) === pos)
                      adf_objects.keywords = filtersdfdata;

                      console.log(adf_objects);
                      debugger;

                    firebase.firestore().collection("adf_forms").add(adf_objects).then(function(adfdetails) {

                      let adf_id = adfdetails.id;
                      adf_objects.adf_form_id = adf_id;

                      let new_adf = adf_objects;
                      firebase.firestore().collection("adf_forms").doc(adf_id).set(new_adf).then(function (querySnapshot2) {


                        firebase.firestore().collection("analytics").where('id','==',1).get().then(function (querySnapshot3) {

                          querySnapshot3.forEach(function (anaDoc) {
                            let old_adf = anaDoc.data().total_adf;
                            let total_adf = parseInt(old_adf) + 1;
                            let old_user = anaDoc.data().total_users;
                            let total_users = parseInt(old_user) + 1;

                            anaDoc.ref.update({
                              total_adf:firebase.firestore.FieldValue.increment(1),
                              total_users:firebase.firestore.FieldValue.increment(1),
                            });

                            let message = "applicant added successfully";

                            let result = {
                              message:message,
                              uid:user_id,
                              adf_form_id:adf_id,
                              status:true
                            }
                            resolve(result);

                          })
                        })


                      })

                      })

                  }
            })

      });

 })

}

  // get applicant contact list data by sending uid

  checkuserexist(user_data: any) {

  let thiss = this;

    return new Promise(function (resolve, reject) {


      //thiss.get_users_table_data(email).subscribe((data)=>{
      firebase.firestore().collection("users").where('email', '==', user_data.email).get().then(function (querySnapshot1) {
        let flag = 0;
        let user_records = [];
        querySnapshot1.forEach(function (userDoc) {
          flag = 1;
          user_records.push(userDoc.data());
        })
        if (flag == 0) {

          firebase.firestore().collection("users").where('mobile_phone', '==', user_data.mobile_phone).get()
            .then(function (querySnapshot2) {
              let flag = 0;
              let userphone_records = [];
              querySnapshot2.forEach(function (userphoneDoc) {
                flag = 1;
                userphone_records.push(userphoneDoc.data());
              })
              if (flag == 0) {

                let password = user_data.password;
                let new_password;
                if(password) {
                   new_password = password;
                }
                else {
                   new_password = thiss.stringGen(12);
                }


                let postData = {
                  'email': user_data.email,
                  'password': new_password
                }
                //console.log(postData);
               // var url = "https://us-central1-sync-afy-dev-sandbox.cloudfunctions.net/createAdfUser";
                var url = thiss.EnvDataService.EnvData.sendbox_api +"/createAdfUser";
                var headers = new Headers();
                headers.append("Accept", 'application/json');
                headers.append('Content-Type', 'application/json' );
                const requestOptions = new RequestOptions({ headers: headers });
                console.log('conatct form service - postData',postData);
                
                thiss._http.post(url, postData, requestOptions).toPromise()
                .then(data => {
                  let newuser =JSON.parse(data['_body']);
                  console.log(newuser);
                  if(newuser.status == 'success'){

                    firebase.firestore().collection("users").doc(user_data.reference_broker).get().then(function (brokersnap) {

                      console.log(newuser.user.uid);
                      let message = "User is not found.";
                      let result = {
                        message: message,
                        uid:newuser.user.uid,
                        broker_data:brokersnap.data(),
                        status: false
                      }
                    resolve(result);

                    })

                  }
                }, error => {
                  console.log(error.message);

                })

                // firebase.auth().createUserWithEmailAndPassword(user_data.email, new_password).then(function(userresult) {

                //   console.log(userresult);
                //   debugger;
                //   let message = "User is not found.";

                //     let result = {
                //       message: message,
                //       status: false,
                //       uid:userresult.user.uid
                //     }
                //     resolve(result);

                // });

              }
              else {
                let message = "Phone number is already exists";

                let result = {
                  message: message,
                  deleted:userphone_records[0].deleted,
                  uid:userphone_records[0].uid,
                  status: true
                }
                resolve(result);
              }
            })
        }
        else {
          let message = "Email is already exists";

          let result = {
            message: message,
            deleted:user_records[0].deleted,
            uid:user_records[0].uid,
            status: true
          }
          resolve(result);
        }
      })

    })

  }
  checknewuserexist(user_data: any) {

    let thiss = this;

      return new Promise(function (resolve, reject) {


        //thiss.get_users_table_data(email).subscribe((data)=>{
        firebase.firestore().collection("users").where('email', '==', user_data.email).get().then(function (querySnapshot1) {
          let flag = 0;
          let user_records = [];
          querySnapshot1.forEach(function (userDoc) {
            flag = 1;
            user_records.push(userDoc.data());
          })
          if (flag == 0) {

            let postData = {
              'email': user_data.email,
              'password': user_data.password
            }
            //console.log(postData);
           // var url = "https://us-central1-sync-afy-dev-sandbox.cloudfunctions.net/createAdfUser";
            var url = thiss.EnvDataService.EnvData.sendbox_api +"/createAdfUser";
            var headers = new Headers();
            headers.append("Accept", 'application/json');
            headers.append('Content-Type', 'application/json' );
            const requestOptions = new RequestOptions({ headers: headers });

            thiss._http.post(url, postData, requestOptions).toPromise()
            .then(data => {
              let newuser =JSON.parse(data['_body']);
              console.log(newuser);
              if(newuser.status == 'success'){

                firebase.firestore().collection("users").doc(user_data.reference_broker).get().then(function (brokersnap) {

                  console.log(newuser.user.uid);

                  let message = "User is not found.";
                  let result = {
                    message: message,
                    uid:newuser.user.uid,
                    broker_data:brokersnap.data(),
                    status: false
                  }
                resolve(result);

                })

              }
            }, error => {
              console.log(error.message);

            })
          }
          else {
            let message = "Email is already exists";

            let result = {
              message: message,
              deleted:user_records[0].deleted,
              uid:user_records[0].uid,
              status: true
            }
            resolve(result);
          }
        })

      })

    }


  createKeywords = name => {
    const arrName = [];
    let curName = '';
    name.split('').forEach(letter => {
      curName += letter;
      arrName.push(curName);
    });
    return arrName;
  }

    // update application status
 // user_id = uid
 // status -> 0 -> restore user
 // status -> 1 -> hard deleted user from users table
 updateUserStatus(user_id,status) {
  let thiss = this;
  console.log(user_id);
  return new Promise((resolve,reject)=>{

    firebase.firestore().collection("users").where('uid','==',user_id).get().then(function (querySnapshot2) {

      let user_details = [];

      querySnapshot2.forEach((doc) => {

        if(status == 0) {
          doc.ref.update({
            deleted:status
          });
        }
        else {
          firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot3) {
            querySnapshot3.forEach((contactdoc) => {
              contactdoc.ref.delete();
            })
            let email = doc.data().email;
            let password = doc.data().password;

            if(password) {
              firebase.auth().signInWithEmailAndPassword(email, password).then(function() {
                // Handle current user here.
                firebase.auth().currentUser.delete()
              });

              doc.ref.delete();
            }
            else {
              let status_message = {
                  status:'error',
                  message: 'something went wrong for deleting this user'
              }
              resolve(status_message);

            }



          })

        }

      });

      if(status == 0) {
        let status_message = {
            status:'success',
            message: 'successfully restore user data from users table'
        }
        resolve(status_message);

      }
      else {
       let status_message = {
            status:'success',
            message: 'successfully deleted user from users table'
        }
        resolve(status_message);

      }



  })


  })
}

  deleteApplicantDetails(user_id) {
    //console.log('sdgj');
    //debugger;
    // user_id = 'nrDWekkC0QaEhfp4Xibh';

    return new Promise((resolve, reject) => {

      firebase.firestore().collection("users").doc(user_id).update({ deleted: 1 }).then(function () {
        // console.log("Document 1 successfully deleted!");
        let flag = 0;
        firebase.firestore().collection("contact_details").where('uid', '==', user_id).get().then(querySnapshot2 => {
          querySnapshot2.forEach((doc) => {
            flag = 1;
            doc.ref.update({ deleted: 1 });
            //console.log("Document 2 successfully deleted!");
          });
        })

        let message = "Document successfully deleted!";
        let result = {
          status: true,
          message: message
        }
        resolve(result)

      }).catch(function (error) {
        console.error("Error removing document: ", error);

        let message = "Error removing document: " + error;
        let result = {
          status: false,
          message: message
        }
        resolve(result)
      });

    })

    //console.log(user_data);

  }

  update_applicant_details(upcoming_object, user_id) {
    console.log(upcoming_object);
    console.log(user_id);
    debugger;
    let children_arr = [];
    let children_length = parseInt(upcoming_object.how_many_children);
    for (let i = 0; i < children_length; i++) {

      if (i == 0) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.first_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 1) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.second_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 2) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.third_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 3) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fourth_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 4) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fifth_child_age)
        }
        children_arr.push(children_object);
      }

    }

    let incomes = [];

    upcoming_object.itemRows.forEach(incomelement => {

      let salary_arr = [];

      for (let i = 0; i <= 5; i++) {

        if (i == 0) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_0),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_0)
          }
          salary_arr.push(salary_object);
        }
        if (i == 1) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_1),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_1)
          }
          salary_arr.push(salary_object);
        }
        if (i == 2) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_2),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_2)
          }
          salary_arr.push(salary_object);
        }
        if (i == 3) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_3),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_3)
          }
          salary_arr.push(salary_object);
        }
        if (i == 4) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_4),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_4)
          }
          salary_arr.push(salary_object);
        }
        if (i == 5) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_5),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_5)
          }
          salary_arr.push(salary_object);
        }

      }

      let income = {
        SDF_form: this.replaceUndefinied(incomelement.SDF_form),
        amount: this.replaceUndefinied(incomelement.amount),
        any_other_allowances: this.replaceUndefinied(incomelement.any_other_allowances),
        comments:this.replaceUndefinied(incomelement.comments),
        created_date:this.replaceUndefinied(incomelement.created_date),
        date_commenced:this.replaceUndefinied(incomelement.date_commenced),
        deleted:0,
        document_id:this.replaceUndefinied(incomelement.document_id),
        frequency:this.replaceUndefinied(incomelement.frequency),
        receive_commissions_bounses:this.replaceUndefinied(incomelement.receive_commissions_bounses),
        receive_moter_vehicle_allowance:this.replaceUndefinied(incomelement.receive_moter_vehicle_allowance),
        receive_overtime:this.replaceUndefinied(incomelement.receive_overtime),
        salary:salary_arr,
        salary_sacrifice:this.replaceUndefinied(incomelement.salary_sacrifice),
        type:this.replaceUndefinied(incomelement.type),
        uid:this.replaceUndefinied(incomelement.uid),
        nature_of_business:this.replaceUndefinied(incomelement.nature_of_business),
        statusyourEmployment:this.replaceUndefinied(incomelement.statusyourEmployment),
        type_of_entity:this.replaceUndefinied(incomelement.type_of_entity),
        your_occupation:this.replaceUndefinied(incomelement.your_occupation)
      }

      incomes.push(income);

    });

    let previous_array = [
      {
        address_type: this.replaceUndefinied(upcoming_object.address_type),
        address_format: this.replaceUndefinied(upcoming_object.address_format),
        full_address: this.replaceUndefinied(upcoming_object.full_address),
        floor_number: this.replaceUndefinied(upcoming_object.floor_number),
        unit_number: this.replaceUndefinied(upcoming_object.unit_number),
        building_name: this.replaceUndefinied(upcoming_object.building_name),
        street_number: this.replaceUndefinied(upcoming_object.street_number),
        street_name: this.replaceUndefinied(upcoming_object.street_name),
        street_type: this.replaceUndefinied(upcoming_object.street_type),
        poboxlabel: this.replaceUndefinied(upcoming_object.poboxlabel),
        city: this.replaceUndefinied(upcoming_object.city),
        state: this.replaceUndefinied(upcoming_object.state),
        postcode: this.replaceUndefinied(upcoming_object.postcode),
        country: this.replaceUndefinied(upcoming_object.country),
        housing_situation: this.replaceUndefinied(upcoming_object.housing_situation),
        move_in_date: this.replaceUndefinied(upcoming_object.move_in_date),
        type: "current"
      },
    ];

    if(upcoming_object.addPreviousAddressItem) {
      upcoming_object.addPreviousAddressItem.forEach(element => {
        let add_obj = {
          deleted: element.deleted,
          address_format: this.replaceUndefinied(element.previous_address_format),
          address_type: this.replaceUndefinied(element.previous_address_type),
          building_name: this.replaceUndefinied(element.previous_building_name),
          city: this.replaceUndefinied(element.previous_city),
          country: this.replaceUndefinied(element.previous_country),
          floor_number: this.replaceUndefinied(element.previous_full_address),
          full_address: this.replaceUndefinied(element.previous_full_address),
          housing_situation: this.replaceUndefinied(element.previous_housing_situation),
          move_in_date: this.replaceUndefinied(element.previous_move_in_date),
          move_out_date: this.replaceUndefinied(element.previous_move_out_date),
          poboxlabel: this.replaceUndefinied(element.previous_poboxlabel),
          postcode: this.replaceUndefinied(element.previous_postcode),
          state: this.replaceUndefinied(element.previous_state),
          street_name: this.replaceUndefinied(element.previous_street_name),
          street_number: this.replaceUndefinied(element.previous_street_number),
          street_type: this.replaceUndefinied(element.previous_street_type),
          unit_number: this.replaceUndefinied(element.previous_unit_number),
          type: "previous"
        }

        previous_array.push(add_obj);

      });
    }


    let applicant_object = {
      user_data: {

        firstname: this.replaceUndefinied(upcoming_object.firstname),
        lastname: this.replaceUndefinied(upcoming_object.lastname),
        middlename: this.replaceUndefinied(upcoming_object.middlename),
        email: this.replaceUndefinied(upcoming_object.email),
        mobile_phone: this.replaceUndefinied(upcoming_object.mobile_phone),
        date_of_birth: this.replaceUndefinied(upcoming_object.date_of_birth),
        reference_broker: this.replaceUndefinied(upcoming_object.reference_broker),
        //password: this.replaceUndefinied(upcoming_object.password),
        deleted: 0,
        created_date: new Date().getTime(),
        roles: {
          contact: true
        },
        uid:user_id
      },
      contact_details: {

        dependent: {

          gender: this.replaceUndefinied(upcoming_object.gender),
          current_marital_status: this.replaceUndefinied(upcoming_object.current_marital_status),
          do_you_have_children: this.replaceUndefinied(upcoming_object.do_you_have_children),
          how_many_children: this.replaceUndefinied(upcoming_object.how_many_children),
          children_age: children_arr
        },
        address: previous_array,
        employment_details:
        {
          employementType: this.replaceUndefinied(upcoming_object.employementType),
          start_date: this.replaceUndefinied(upcoming_object.start_date),
          currentlyEmployment: this.replaceUndefinied(upcoming_object.currentlyEmployment),
          expectFindWork: this.replaceUndefinied(upcoming_object.expectFindWork),
          statusyourEmployment: this.replaceUndefinied(upcoming_object.statusyourEmployment),
          your_occupation: this.replaceUndefinied(upcoming_object.your_occupation),
          business_name: this.replaceUndefinied(upcoming_object.business_name),
          type_of_entity: this.replaceUndefinied(upcoming_object.type_of_entity),
          addPrimaryEmploymentItem: this.replaceUndefinied(upcoming_object.addPrimaryEmploymentItem),
          abn_acn: this.replaceUndefinied(upcoming_object.abn_acn),
          nature_of_business: this.replaceUndefinied(upcoming_object.nature_of_business),
          created_date: new Date().getTime(),
          deleted: 0,
          incomes: incomes,
        },

        uid: user_id,
        deleted: 0,
        created_date: new Date().getTime(),
        roles: {
          contact: true
        }
      }
    }

    console.log('upcoming_object',upcoming_object);
    console.log('applicant_object',applicant_object);
    debugger;
    return new Promise((resolve, reject) => {

      firebase.firestore().collection("users").doc(user_id).update(applicant_object.user_data).then(function (querySnapshot2) {
        if (applicant_object.contact_details) {

          firebase.firestore().collection("contact_details").where('uid', '==', user_id).get().then(response => {
            let batch = firebase.firestore().batch()
            let flag = 0;
            response.docs.forEach((doc) => {
              flag = 1;
              console.log('found');
              const docRef = firebase.firestore().collection("contact_details").doc(doc.id)
              batch.update(docRef, applicant_object.contact_details)
            })
            batch.commit().then(() => {
              //console.log(`updated all documents inside contact_details`);
            })
            if (flag == 0) {
              firebase.firestore().collection("contact_details").add(applicant_object.contact_details).then(function (details) {
                //console.log('working');
              })
            }




          })
        }

        firebase.firestore().collection("adf_forms").where('primary_contact_id','==',user_id).get().then(function (querySnapshot2) {

          let adf_data = [];

          querySnapshot2.forEach((adfdetailsdoc) => {
            let a_data = adfdetailsdoc.data();
              let all_contacts = [];

              a_data.contacts.forEach(contactelement => {
                  if(contactelement.user_data.uid == user_id) {
                    contactelement.user_data = applicant_object.user_data;
                    contactelement.contact_details = applicant_object.contact_details;
                  }
                  all_contacts.push(contactelement);
              });

                adfdetailsdoc.ref.update({
                  contacts:all_contacts
                });
                adf_data.push(a_data);

          });

          firebase.firestore().collection("user_events").where('uid','==',user_id).get().then(function (querySnapshot2) {

            querySnapshot2.forEach((eventdetailsdoc) => {
              eventdetailsdoc.ref.update({
                event_status:1
              })
            });
            let message = 'updated all documents inside contact_details';

              let result = {
                status: 'success',
                message: message
              }
              resolve(result)
            //resolve(adf_data);

          })


        })
        // firebase.firestore().collection("user_events").doc(user_id).set({
        //   uid:user_id,
        //     event_type:'Contact_Update',
        //     event_status:0
        //   }).then(function (querySnapshot2) {
        //       let message = 'updated all documents inside contact_details';
        //       let result = {
        //         status: 'success',
        //         message: message
        //       }
        //       resolve(result)
        //   })




      })
    })
  }

  update_personal_details(upcoming_object,user_id) {

    let previous_array = [
      {
        address_type: this.replaceUndefinied(upcoming_object.address_type),
        address_format: this.replaceUndefinied(upcoming_object.address_format),
        full_address: this.replaceUndefinied(upcoming_object.full_address),
        floor_number: this.replaceUndefinied(upcoming_object.floor_number),
        unit_number: this.replaceUndefinied(upcoming_object.unit_number),
        building_name: this.replaceUndefinied(upcoming_object.building_name),
        street_number: this.replaceUndefinied(upcoming_object.street_number),
        street_name: this.replaceUndefinied(upcoming_object.street_name),
        street_type: this.replaceUndefinied(upcoming_object.street_type),
        poboxlabel: this.replaceUndefinied(upcoming_object.poboxlabel),
        city: this.replaceUndefinied(upcoming_object.city),
        state: this.replaceUndefinied(upcoming_object.state),
        postcode: this.replaceUndefinied(upcoming_object.postcode),
        country: this.replaceUndefinied(upcoming_object.country),
        housing_situation: this.replaceUndefinied(upcoming_object.housing_situation),
        move_in_date: this.replaceUndefinied(upcoming_object.move_in_date),
        type: "current"
      },
    ];

    if(upcoming_object.addPreviousAddressItem) {
      upcoming_object.addPreviousAddressItem.forEach(element => {
        let add_obj = {
          deleted: element.deleted,
          address_format: this.replaceUndefinied(element.previous_address_format),
          address_type: this.replaceUndefinied(element.previous_address_type),
          building_name: this.replaceUndefinied(element.previous_building_name),
          city: this.replaceUndefinied(element.previous_city),
          country: this.replaceUndefinied(element.previous_country),
          floor_number: this.replaceUndefinied(element.previous_full_address),
          full_address: this.replaceUndefinied(element.previous_full_address),
          housing_situation: this.replaceUndefinied(element.previous_housing_situation),
          move_in_date: this.replaceUndefinied(element.previous_move_in_date),
          move_out_date: this.replaceUndefinied(element.previous_move_out_date),
          poboxlabel: this.replaceUndefinied(element.previous_poboxlabel),
          postcode: this.replaceUndefinied(element.previous_postcode),
          state: this.replaceUndefinied(element.previous_state),
          street_name: this.replaceUndefinied(element.previous_street_name),
          street_number: this.replaceUndefinied(element.previous_street_number),
          street_type: this.replaceUndefinied(element.previous_street_type),
          unit_number: this.replaceUndefinied(element.previous_unit_number),
          type: "previous"
        }

        previous_array.push(add_obj);

      });
    }


    let applicant_object = {
      user_data: {

        firstname: this.replaceUndefinied(upcoming_object.firstname),
        lastname: this.replaceUndefinied(upcoming_object.lastname),
        middlename: this.replaceUndefinied(upcoming_object.middlename),
        email: this.replaceUndefinied(upcoming_object.email),
        mobile_phone: this.replaceUndefinied(upcoming_object.mobile_phone),
        date_of_birth: this.replaceUndefinied(upcoming_object.date_of_birth),
        reference_broker: this.replaceUndefinied(upcoming_object.reference_broker),
        //password: this.replaceUndefinied(upcoming_object.password),

      },
      contact_details: {
        address: previous_array
      }
    }
    console.log(applicant_object);
    return new Promise((resolve,reject)=>{

      firebase.firestore().collection("users").where('uid','==',user_id).get().then(function (querySnapshot2) {
        querySnapshot2.forEach(function (userDoc) {
            userDoc.ref.update(applicant_object.user_data);
           // resolve(userDoc.data());

            firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot2) {
              let flag = 0;
              querySnapshot2.forEach(function (contactDoc) {
                 flag = 1;
                  contactDoc.ref.update({
                    address:applicant_object.contact_details.address
                  });
                  firebase.firestore().collection("user_events").doc(user_id).set({
                    uid:user_id,
                    event_type:'Contact_Update',
                    event_status:0
                  }).then(function (querySnapshot2) {
                      resolve(true);
                  })

              })
              if(flag == 0) {
                firebase.firestore().collection("contact_details").add({
                  address:applicant_object.contact_details.address,
                  deleted:0,
                  dependent:{},
                  employment_details:{},

                  roles:{
                    contact:true
                  },
                  uid:user_id
                }).then(function (querySnapshot2) {

                  firebase.firestore().collection("user_events").doc(user_id).set({
                    uid:user_id,
                    event_type:'Contact_Update',
                    event_status:0
                  }).then(function (querySnapshot2) {
                      resolve(true);
                  })

                })
              }

            })
        })
      })
    })
  }
  update_dependent_details(upcoming_object,user_id) {

    let children_arr = [];
    let children_length = parseInt(upcoming_object.how_many_children);
    for (let i = 0; i < children_length; i++) {

      if (i == 0) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.first_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 1) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.second_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 2) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.third_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 3) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fourth_child_age)
        }
        children_arr.push(children_object);
      }
      if (i == 4) {
        let children_object = {
          age: this.replaceUndefinied(upcoming_object.fifth_child_age)
        }
        children_arr.push(children_object);
      }

    }

    let gender = this.replaceUndefinied(upcoming_object.gender);
    let current_marital_status = this.replaceUndefinied(upcoming_object.current_marital_status);
    let do_you_have_children = this.replaceUndefinied(upcoming_object.do_you_have_children);
    let how_many_children =  this.replaceUndefinied(upcoming_object.how_many_children);

   let dependent = {
      gender: gender,
      current_marital_status: current_marital_status,
      do_you_have_children: do_you_have_children,
      how_many_children: how_many_children,
      children_age: children_arr
    }

    return new Promise((resolve,reject)=>{

        let flag  = 0;
      firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot2) {
        querySnapshot2.forEach(function (contactDoc) {
           flag = 1;
            contactDoc.ref.update({
              dependent:dependent
            });
            firebase.firestore().collection("user_events").doc(user_id).set({
              uid:user_id,
              event_type:'Contact_Update',
              event_status:0
            }).then(function (querySnapshot2) {
              resolve(contactDoc.data());
            })

        })
         if(flag == 0) {
          let contact_details = {
            dependent:dependent,
            created_date:new Date().getTime(),
            delete:0,
            roles:{
              contact:true
            },
            uid:user_id
         }
        firebase.firestore().collection("contact_details").add(contact_details).then(function (querySnapshot2) {

          firebase.firestore().collection("user_events").doc(user_id).set({
            uid:user_id,
            event_type:'Contact_Add',
            event_status:0
          }).then(function (querySnapshot2) {
              resolve(true);
          })

        })
         }
      })
    })
  }

  update_employment_details(upcoming_object,user_id) {

    debugger;
    let employment_details =
    {
      employementType: this.replaceUndefinied(upcoming_object.employementType),
      start_date: this.replaceUndefinied(upcoming_object.start_date),
      currentlyEmployment: this.replaceUndefinied(upcoming_object.currentlyEmployment),
      expectFindWork: this.replaceUndefinied(upcoming_object.expectFindWork),
      statusyourEmployment: this.replaceUndefinied(upcoming_object.statusyourEmployment),
      your_occupation: this.replaceUndefinied(upcoming_object.your_occupation),
      business_name: this.replaceUndefinied(upcoming_object.business_name),
      type_of_entity: this.replaceUndefinied(upcoming_object.type_of_entity),
      addPrimaryEmploymentItem: this.replaceUndefinied(upcoming_object.addPrimaryEmploymentItem),
      abn_acn: this.replaceUndefinied(upcoming_object.abn_acn),
      nature_of_business: this.replaceUndefinied(upcoming_object.nature_of_business),
      incomes:[]
    };

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot2) {
        //resolve(true);
         let flag = 0
        querySnapshot2.forEach(function (contactDoc) {
            let contactdata = contactDoc.data();
             flag = 1;
             if(contactdata.employment_details) {
                if(contactdata.employment_details.incomes) {
                  employment_details.incomes = contactdata.employment_details.incomes
                }
             }


            contactDoc.ref.update({
              employment_details:employment_details
            });
            firebase.firestore().collection("user_events").doc(user_id).set({
              uid:user_id,
              event_type:'Contact_Update',
              event_status:0
            }).then(function (querySnapshot2) {
              resolve(contactDoc.data());
            })
            //resolve(contactDoc.data());
        })
         if(flag == 0) {
           let contact_details = {
              employment_details:employment_details,
              created_date:new Date().getTime(),
              delete:0,
              roles:{
                contact:true
              },
              uid:user_id
           }
          firebase.firestore().collection("contact_details").add(contact_details).then(function (querySnapshot2) {

            firebase.firestore().collection("user_events").doc(user_id).set({
              uid:user_id,
              event_type:'Contact_Add',
              event_status:0
            }).then(function (querySnapshot2) {
                resolve(true);
            })

          })
         }

      })
    })
  }
  update_income_details(upcoming_object,user_id) {
    debugger;
    let incomes = [];

    upcoming_object.itemRows.forEach(incomelement => {

      let salary_arr = [];

      for (let i = 0; i <= 5; i++) {

        if (i == 0) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_0),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_0)
          }
          salary_arr.push(salary_object);
        }
        if (i == 1) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_1),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_1)
          }
          salary_arr.push(salary_object);
        }
        if (i == 2) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_2),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_2)
          }
          salary_arr.push(salary_object);
        }
        if (i == 3) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_3),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_3)
          }
          salary_arr.push(salary_object);
        }
        if (i == 4) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_4),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_4)
          }
          salary_arr.push(salary_object);
        }
        if (i == 5) {
          let salary_object = {
            payslip: this.replaceUndefinied(incomelement.sallary_payslip_5),
            payslip_name: this.replaceUndefinied(incomelement.sallary_payslip_name_5)
          }
          salary_arr.push(salary_object);
        }

      }

      let income = {
        SDF_form: this.replaceUndefinied(incomelement.SDF_form),
        amount: this.replaceUndefinied(incomelement.amount),
        any_other_allowances: this.replaceUndefinied(incomelement.any_other_allowances),
        comments:this.replaceUndefinied(incomelement.comments),
        created_date:this.replaceUndefinied(incomelement.created_date),
        date_commenced:this.replaceUndefinied(incomelement.date_commenced),
        deleted:0,
        document_id:this.replaceUndefinied(incomelement.document_id),
        frequency:this.replaceUndefinied(incomelement.frequency),
        receive_commissions_bounses:this.replaceUndefinied(incomelement.receive_commissions_bounses),
        receive_moter_vehicle_allowance:this.replaceUndefinied(incomelement.receive_moter_vehicle_allowance),
        receive_overtime:this.replaceUndefinied(incomelement.receive_overtime),
        salary:salary_arr,
        salary_sacrifice:this.replaceUndefinied(incomelement.salary_sacrifice),
        type:this.replaceUndefinied(incomelement.type),
        uid:this.replaceUndefinied(incomelement.uid),
        nature_of_business:this.replaceUndefinied(incomelement.nature_of_business),
        statusyourEmployment:this.replaceUndefinied(incomelement.statusyourEmployment),
        type_of_entity:this.replaceUndefinied(incomelement.type_of_entity),
        your_occupation:this.replaceUndefinied(incomelement.your_occupation)
      }

      incomes.push(income);

    });

    let newemployment_details =
    {
      incomes:incomes
    };

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("contact_details").where('uid','==',user_id).get().then(function (querySnapshot2) {
        let flag = 0;

        querySnapshot2.forEach(function (contactDoc) {
          let contactdata = contactDoc.data();
          flag = 1;
          let employment_details = contactdata.employment_details;
           employment_details.incomes = newemployment_details.incomes;
            contactDoc.ref.update({
              employment_details:employment_details
            });
            firebase.firestore().collection("user_events").doc(user_id).set({
              uid:user_id,
              event_type:'Contact_Update',
              event_status:0
            }).then(function (querySnapshot2) {
              resolve(contactDoc.data());
            })
            // resolve(contactDoc.data());
        })

        if(flag == 0) {
          let contact_details = {
            employment_details:{
              incomes:newemployment_details.incomes
            },
            created_date:new Date().getTime(),
            delete:0,
            roles:{
              contact:true
            },
            uid:user_id
         }
        firebase.firestore().collection("contact_details").add(contact_details).then(function (querySnapshot2) {

          firebase.firestore().collection("user_events").doc(user_id).set({
            uid:user_id,
            event_type:'Contact_Add',
            event_status:0
          }).then(function (querySnapshot2) {
              resolve(true);
          })

        })
         }
      })
    })
  }

  replaceUndefinied(item) {
   if(item == undefined) {
     return '';
   }
   else {
     return item;
   }
 }

 getApplicantDetails(user_id) {

  console.log('working');
  debugger;
  return new Promise((resolve, reject) => {
    let users_collection;

    firebase.firestore().collection("users").doc(user_id).get().then(querySnapshot2 => {

      let user_data = querySnapshot2.data();

      console.log(user_id);
      firebase.firestore().collection("contact_details").where("uid", "==", user_id).get().then(function (details) {

        //console.log(detail);
        let contact_details = [];
        details.forEach(function (result) {
          //console.log(empDoc.data());
          let contact_data = result.data();
          contact_details.push(contact_data)

        })

        if(!user_data.allowCustoViewOnlyPermission) {
          user_data.allowCustoViewOnlyPermission = 0;
        }
        if(!user_data.allowCustoeditPermission) {
          user_data.allowCustoeditPermission = 0;
        }

        if(!user_data.accessGrantedFromUser) {
          user_data.accessGrantedFromUser = 0;
        }
        if(!user_data.accessPermission) {
          user_data.accessPermission = 0;
        }

        users_collection = {
          user_data: user_data,
          contact_details: contact_details[0]
        }

        resolve(users_collection);


      })

    })



  })

}

  // get all applicants contact list data

  getAllApplicantContact(limit:any='', offset:any='',broker_reference:any= '') {
    debugger;
    let total_data = limit * offset;

    if(limit !== '' && offset!=='') {
      console.log('shgd')
      return new Promise(function (resolve, reject) {

        if(broker_reference == '') {
          firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(total_data).get()
          .then(function (querySnapshot2) {
            console.log(querySnapshot2);
            let userlist = [];
            querySnapshot2.forEach( function (contDoc) {
              //console.log(empDoc.data());
              let contact_data = contDoc.data();
              contact_data.uid = contDoc.id;
              userlist.push(contact_data)
            })
            resolve(userlist);

          })
        }
        else {
          console.log('abcdf')
          console.log(total_data);
          firebase.firestore().collection("users").where("deleted","==",0).where('reference_broker', 'in', broker_reference).orderBy('created_date', 'desc').limit(total_data).get()
          .then(function (querySnapshot2) {
            console.log(querySnapshot2);
            let userlist = [];
            querySnapshot2.forEach( function (contDoc) {
              console.log(contDoc.data());
              let contact_data = contDoc.data();
              contact_data.uid = contDoc.id;
              userlist.push(contact_data)
            })
            resolve(userlist);

          })
        }


      }).then((userlist:any)=>{
        console.log(userlist);
        let users_finlist= []
        return new Promise((resolve,reject)=>{
          const requests = userlist.map(function(userdata){

            const promise = new Promise(function (resolve, reject) {
              console.log(userdata.reference_broker);
              if(userdata.reference_broker) {
                firebase.firestore().collection("users").doc(userdata.reference_broker).get().then(function (brokersnap) {
                  //console.log('abc');
                    userdata.broker_data = brokersnap.data();
                    users_finlist.push(userdata);
                    resolve(true);
                  })
              }
              else {
                userdata.broker_data = null;
                users_finlist.push(userdata);
                resolve(true);
              }

            })
            return promise;
          })

          Promise.all(requests).then(function (result) {
            console.log('all promiseall')
            resolve(users_finlist)
          })
        })

      });
    }
    else{
      return new Promise(function (resolve, reject) {

        if(broker_reference == '') {
            firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').get()
            .then(function (querySnapshot2) {
              console.log(querySnapshot2);
              let userlist = [];
              querySnapshot2.forEach(function (contDoc) {
                console.log(contDoc.data());
                let contact_data = contDoc.data();
                contact_data.uid = contDoc.id;
                userlist.push(contact_data)

              })

              resolve(userlist)

            })
        }
        else {
          firebase.firestore().collection("users").where("deleted","==",0).where('reference_broker', 'array-contains', broker_reference).orderBy('created_date', 'desc').get()
          .then(function (querySnapshot2) {
            console.log(querySnapshot2);
            let userlist = [];
            querySnapshot2.forEach( function (contDoc) {
              //console.log(empDoc.data());
              let contact_data = contDoc.data();
              contact_data.uid = contDoc.id;
              userlist.push(contact_data)
            })
            resolve(userlist);

          })
        }


      })
      .then((userlist:any)=>{
        console.log(userlist);
        let users_finlist= []
        return new Promise((resolve,reject)=>{
          const requests = userlist.map(function(userdata){

            const promise = new Promise(function (resolve, reject) {
              console.log(userdata.reference_broker);
              if(userdata.reference_broker) {
                firebase.firestore().collection("users").doc(userdata.reference_broker).get().then(function (brokersnap) {
                  //console.log('abc');
                    userdata.broker_data = brokersnap.data();
                    users_finlist.push(userdata);
                    resolve(true);
                  })
              }
              else {
                userdata.broker_data = null;
                users_finlist.push(userdata);
                resolve(true);
              }

            })
            return promise;
          })

          Promise.all(requests).then(function (result) {
            console.log('all promiseall')
            resolve(users_finlist)
          })
        })

      });

    }



  }

 // getting users data
 getUserdata(uid) {
  return new Promise((resolve,reject)=>{
    firebase.firestore().collection("users").doc(uid).get()
        .then(function (querySnapshot2) {
          let broker_data = querySnapshot2.data();
            resolve(broker_data);
        })
  })
 }
  // getting employment and income details by sending sdf form id

  getEmploymentandIncomeBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("employment").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let employmentlist = [];
          querySnapshot2.forEach(function (empDoc) {
            //console.log(empDoc.data());
            let employment_data = empDoc.data();
            employmentlist.push(employment_data)
          })
          //console.log(employmentlist);

          resolve(employmentlist)

        })

    }).then(function (employmentlist) { // (**)

      return new Promise((resolve, reject) => { // (*)

        firebase.firestore().collection("SDF_income").where("SDF_form", "==", SDF_form_document_id).get()
          .then(function (querySnapshot2) {
            let incomelist = [];
            querySnapshot2.forEach(function (incDoc) {
              //console.log(empDoc.data());
              let income_data = incDoc.data();
              incomelist.push(income_data)
            })
            let finalresult = {
              employmentlist: employmentlist,
              incomelist: incomelist
            }

            //return finalresult;
            resolve(finalresult)
          })
      });

    })

  }
  // getting assets and liability details by sending sdf form id

  getAssetsandLiabilityBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("SDF_assets").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let assetslist = [];
          querySnapshot2.forEach(function (asstDoc) {
            //console.log(empDoc.data());
            let assets_data = asstDoc.data();
            assetslist.push(assets_data)
          })
          //console.log(employmentlist);

          resolve(assetslist)

        })

    }).then(function (assetslist) { // (**)

      return new Promise((resolve, reject) => { // (*)

        firebase.firestore().collection("SDF_liabilities").where("SDF_form", "==", SDF_form_document_id).get()
          .then(function (querySnapshot2) {
            let liabilitylist = [];
            querySnapshot2.forEach(function (liaDoc) {
              //console.log(empDoc.data());
              let liability_data = liaDoc.data();
              liabilitylist.push(liability_data)
            })
            let finalresult = {
              assetslist: assetslist,
              liabilitylist: liabilitylist
            }

            //return finalresult;
            resolve(finalresult)
          })
      });

    })

  }

  // getting realestate details by sending sdf form id

  getRealestateBySDFId(SDF_form_document_id) {


    return new Promise(function (resolve, reject) {

      firebase.firestore().collection("SDF_realestate").where("SDF_form", "==", SDF_form_document_id).get()
        .then(function (querySnapshot2) {
          console.log(querySnapshot2);
          let realestatelist = [];
          querySnapshot2.forEach(function (realDoc) {
            //console.log(empDoc.data());
            let realestae_data = realDoc.data();
            realestatelist.push(realestae_data)
          })
          //console.log(employmentlist);

          resolve(realestatelist)

        })

    })

  }

  get_first_user_data(SDF_form_document_id, uid) {
    return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
  }
  get_second_user_data(SDF_form_document_id) {
    return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('contact_type', '==', 'Secondary Contact').where('SDF_form_document_id', '==', SDF_form_document_id).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
  }

  get_users_table_data(email_id) {
    console.log(email_id);
    return this.db.collection<any>("users", ref => ref.where('created_date', '>', 0).where('email', '==', email_id).orderBy('created_date', 'desc')).valueChanges();
  }
  get_users_table_dataByPhone(phone_number) {
    return this.db.collection<any>("users", ref => ref.where('created_date', '>', 0).where('mobile_phone', '==', phone_number).orderBy('created_date', 'desc')).valueChanges();
  }

  // load applicant data
  loadAllApplicantData(endBefore, limit) {

    if (endBefore == '') {
      console.log('its working');
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(limit).get().then((querySnapshot2) => {
          let userlist = [];
          querySnapshot2.forEach(function (contDoc) {
            //console.log(empDoc.data());
            let contact_data = contDoc.data();
            contact_data.uid = contDoc.id
            if (contact_data.deleted == 0) {
              userlist.push(contact_data)
            }


          })
          //console.log(employmentlist);

          resolve(userlist)

        });
      })
    }
    else {
      console.log('its not working');
      return new Promise((resolve, reject) => {
        firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).orderBy('created_date', 'desc').limit(limit).startAfter(endBefore).get().then((querySnapshot2) => {
          let userlist = [];
          querySnapshot2.forEach(function (contDoc) {
            //console.log(empDoc.data());
            let contact_data = contDoc.data();
            contact_data.uid = contDoc.id
            if (contact_data.deleted == 0) {
              userlist.push(contact_data)
            }

            resolve(userlist)
          })

        });
      })

    }

  }

  // Adf application list by user id

  getAllApplicantDetailsbyId(user_id) {
    console.log('user_id getAllApplicantDetailsbyId',user_id)
    return new Promise((resolve,reject)=>{
      //.where('primary_contact_id', '==', user_id).orderBy('created_date', 'desc')
      firebase.firestore().collection("adf_forms").where("deleted","==",0).where('user_ids', 'array-contains', user_id).orderBy('created_date', 'desc').get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();
          adf_details.push(adf_data)

        })

        resolve(adf_details);
    })


    })
  }
  getAllOpenApplicantDetailsbyId(user_id) {
    console.log('user_id getAllApplicantDetailsbyId',user_id)
    return new Promise((resolve,reject)=>{
      //.where('primary_contact_id', '==', user_id).orderBy('created_date', 'desc')
      firebase.firestore().collection("adf_forms").where('application_status',"==","open").where("deleted","==",0).where('user_ids', 'array-contains', user_id).orderBy('created_date', 'desc').get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();
          adf_details.push(adf_data)

        })

        resolve(adf_details);
    })


    })
  }
  // Adf application delete by user id and adf id

  deleteSpecificApplication(uid,afdID) {
    console.log(uid);
    console.log(afdID);
    debugger;
    return new Promise((resolve, reject) => {

      firebase.firestore().collection("adf_forms").where('adf_form_id','==',afdID).get().then(function (querySnapshot2) {
        // console.log("Document 1 successfully deleted!");
        querySnapshot2.forEach((doc) => {

          doc.ref.update({ deleted: 1 });
          console.log("Document 2 successfully deleted!");
          console.log(doc.data());
        });

        let message = "Document successfully deleted!";
        let result = {
          status: true,
          message: message
        }
        resolve(result)

      }).catch(function (error) {
        console.error("Error removing document: ", error);

        let message = "Error removing document: " + error;
        let result = {
          status: false,
          message: message
        }
        resolve(result)
      });

    })
  }


  updateuserpermissionbyid(user_id,allowCustoViewOnlyPermission,allowCustoeditPermission) {


    debugger;
    // user_id = 'FIvXEG36ETtth5uLBBgK';
    // allowCustoViewOnlyPermission=1;
    // allowCustoeditPermission=1;

    return new Promise((resolve, reject) => {
      //let users_collection;
      firebase.firestore().collection("users").doc(user_id).
      update({
        allowCustoViewOnlyPermission:allowCustoViewOnlyPermission,
        allowCustoeditPermission:allowCustoeditPermission
      }).then(function () {

        let status = 'success';
        let message = 'user is updated';

        let result = {
          status:status,
          message:message
        }
        resolve(result);

      })

    })

  }

  getspecificApplicationsById(adf_id) {

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', adf_id).get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          console.log('result',result.data());
          let adf_data = result.data();
          adf_details.push(adf_data)

        })

        resolve(adf_details[0]);
    })


    })
}

stringGen(len) {
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
}

  cloneApplicantDetailsbyId(adf_id) {
    return new Promise((resolve,reject)=>{

      firebase.firestore().collection("adf_forms").where('adf_form_id', '==', adf_id).get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          console.log('result',result.data());
          let adf_data = result.data();
          adf_data.adf_form_id = '';
          adf_data.created_date = new Date().getTime();
          adf_data.application_status = 'open';

          var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth()+1;
            var yyyy = today.getFullYear();


            let newtoday = dd+'/'+mm+'/'+yyyy;

          // adf_data.title = 'Copy -'+adf_data.clone+' '+adf_data.title+' - '+newtoday
          adf_data.title = 'Copy - '+adf_data.title+' - '+newtoday+ ' '+new Date().getTime()
          firebase.firestore().collection("contact_details").add(adf_data).then(function(adfdetails) {

                  let newadf_id = adfdetails.id;
                  adf_data.adf_form_id = newadf_id;


                  firebase.firestore().collection("adf_forms").doc(newadf_id).set(adf_data).then(function (querySnapshot2) {

                    let message = "applicant added successfully";

                        let result = {
                          message:message,
                          user_id:adf_data.primary_contact_id,
                          adf_form_id:newadf_id,
                          status:true
                        }
                      resolve(result);

                  })

          })
          //adf_details.push(adf_data)

        })

        //resolve(adf_details[0]);
    })
    })
  }
  getCloneAdfList(user_id) {

    let today =  Date.now();
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("adf_forms").where("deleted","==",0).where('user_ids', 'array-contains', user_id).startAt('created_date', today).endAt('created_date', today).get().then(function (querySnapshot2) {
        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();
          adf_details.push(adf_data)

        })

        resolve(adf_details);
      })
    })

  }
  searchAllContacts(search) {
    let keyword = search.toLowerCase();
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("users").where('roles.contact', '==', true).where('deleted', '==', 0).where('keywords', 'array-contains', keyword).orderBy('created_date', 'desc').get()
      .then(function (querySnapshot2) {
        console.log(querySnapshot2);
        let userlist = [];
        querySnapshot2.forEach( function (contDoc) {
          //console.log(empDoc.data());
          let contact_data = contDoc.data();

          if(contact_data.reference_broker) {
            firebase.firestore().collection("users").doc(contact_data.reference_broker).get().then(function (brokersnap) {
              //console.log('abc');
                contact_data.broker_data = brokersnap.data();
                userlist.push(contact_data)
                //resolve(true);
              })
          }
          else {
            contact_data.broker_data = null;
            userlist.push(contact_data)
            //resolve(true);
          }


        })
        resolve(userlist);

      })
  })
  }

  getstateMessage(stage_id) {

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("active_deals").where('stage', 'array-contains', stage_id).get()
      .then(function (querySnapshot2) {
        console.log(querySnapshot2);
        let userlist = [];
        querySnapshot2.forEach( function (stageDoc) {
          //console.log(empDoc.data());
          let stage_data = stageDoc.data();
            resolve(stage_data);

        })

      })
  })
  }

  getallapplicants(user_id) {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("adf_forms").where('user_ids', 'array-contains', user_id).get().then(function (querySnapshot2) {

        let adf_details = [];
        querySnapshot2.forEach(function (result) {
          //console.log(empDoc.data());
          let adf_data = result.data();
          if(!adf_data.accessGrantedFromUser) {
            adf_details.push(adf_data)
          }


        })

        resolve(adf_details);
      })
    })
  }

  updateuserbroker(user_id,reference_broker) {
    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("users").where('uid', '==', user_id).get().then(function (querySnapshot2) {

        querySnapshot2.forEach(function (userdoc) {
          //console.log(empDoc.data());
          userdoc.ref.update({
            reference_broker:reference_broker
          })

        })

        firebase.firestore().collection("adf_forms").where('primary_contact_id', '==', user_id).get().then(function (querySnapshot3) {
          querySnapshot3.forEach(function (adfdoc) {
            //console.log(empDoc.data());
            adfdoc.ref.update({
              reference_broker:reference_broker
            })

          })

            resolve(true);
        })

        //resolve(true);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/services/contact-form.service.ts